import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Typography, Fade, makeStyles } from '@material-ui/core';
import Tooltip from '../tooltip';
import { ReactComponent as TasksIcon } from '../../../assets/icons/format_list_bulleted.svg';

const useStyles = makeStyles(({ spacing }) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    cursor: 'default',
    width: 16,
    height: 16,
  },
  iconWithTasks: {
    marginRight: spacing(1),
  },
  tasks: {
    marginBottom: spacing(-0.5),
  },
}));

const TasksIconTooltip = ({
  className = undefined,
  iconClass = undefined,
  text,
  numberOfTasks = 0,
  isVisible = false,
}) => {
  const classes = useStyles();
  const hasTasks = numberOfTasks !== 0;

  return (
    <Fade
      className={classNames(classes.root, className)}
      in={isVisible}
      unmountOnExit
    >
      <div className={classes.root}>
        <Tooltip
          customIconClass={classNames(
            classes.icon,
            {
              [classes.iconWithTasks]: hasTasks,
            },
            iconClass
          )}
          text={text}
          icon={TasksIcon}
        />
        {hasTasks && (
          <Typography variant="subtitle2" className={classes.tasks}>
            {numberOfTasks}
          </Typography>
        )}
      </div>
    </Fade>
  );
};

TasksIconTooltip.propTypes = {
  className: PropTypes.string,
  iconClass: PropTypes.string,
  text: PropTypes.string.isRequired,
  numberOfTasks: PropTypes.number,
  isVisible: PropTypes.bool,
};

export default TasksIconTooltip;
